import styled from 'styled-components';
import ProfilePhotoProps from './type';

export const ProfilePhotoWrapperStyled = styled.div<ProfilePhotoProps>`
  position: relative;
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size}px`};
  border-radius: 50%;
  transition: all 0.3s ease-in-out;

  ::before {
    content: '';
    position: absolute;
    z-index: -2;
    height: calc(${({ size }) => `${size}px`} + 5px);
    width: calc(${({ size }) => `${size}px`} + 5px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: linear-gradient(140deg, #0057b8, #50caff);
    transition: all 0.3s ease-in-out;
  }
  ::after {
    content: '';
    position: absolute;
    z-index: -1;
    height: calc(${({ size }) => `${size}px`} + 1px);
    width: calc(${({ size }) => `${size}px`} + 1px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: #fff;
    transition: all 0.3s ease-in-out;
  }
`;

export const ProfilePhotoImgStyled = styled.img<ProfilePhotoProps>`
  object-fit: cover;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
`;
